import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  width: null,
  isANewUser: false,
};

export const UserSlice = createSlice({
  name: 'userinfo',
  initialState,
  reducers: {
    handleNewUser: (state, action) => {
      state.isANewUser = action.payload;
    },
  },
});

export const { handleNewUser } = UserSlice.actions;

export const widthSelector = state => state.userinfo.width;
export const isANewUserSelector = state => state.userinfo.isANewUser;

export default UserSlice.reducer;
